package com.zi.support.shared

/**
 * Search on Tickets, Calls and Issues (web, Android, iOS): every record from the last [DAYS] days is loaded and
 * matched here, so a search finds words anywhere in a record, not only what the list already shows.
 */
object RecentSearch {
    const val DAYS: Int = 90
    /** ponytail: a cap on the 90-day load; search a server index (Algolia/Typesense) if a quarter outgrows it. */
    const val LIMIT: Int = 5000
    private const val DAY_MS = 86_400_000.0

    /** Start of the search window, for a `>=` query on the record's date. */
    fun sinceMillis(nowMillis: Double): Double = nowMillis - DAYS * DAY_MS

    /**
     * Every typed word appears somewhere in [texts], in any order and any case: "printer problems" matches "Problems with
     * the printer". A phone number (6+ digits) matches however it was typed or stored: "076 271 3345" finds +27762713345.
     */
    fun matches(query: String, texts: List<String>): Boolean {
        val words = query.lowercase().split(' ', '\t', '\n').filter { it.isNotBlank() }
        if (words.isEmpty()) return true
        val digits = query.filter { it.isDigit() }
        if (digits.length >= 6 && digits.length * 2 >= query.count { !it.isWhitespace() }) {
            val wanted = national(digits)
            if (texts.any { national(it.filter { c -> c.isDigit() }).contains(wanted) }) return true
        }
        val haystack = texts.joinToString(" ").lowercase()
        return words.all { it in haystack }
    }

    /** A South African number without its 0 or 27 prefix, so 076…, 2776… and +2776… compare equal. */
    private fun national(digits: String): String = when {
        digits.length >= 11 && digits.startsWith("27") -> digits.drop(2)
        digits.startsWith("0") -> digits.drop(1)
        else -> digits
    }
}
